import {
  pagedListWrapper,
  singleItemWrapper,
  listItemWrapper
} from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { Season, Level, DetailedSeason, ClaimResponse } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const { get: getSeason } = singleItemWrapper<DetailedSeason>(apiClient, {
      path: `/api/v${version}/battlepass/season`
    })

    const seasons = pagedListWrapper<'id', Season>()(apiClient, {
      path: `/api/v${version}/battlepass/seasons`,
      idKey: 'id'
    })

    const { getItem: getSeasonById } = listItemWrapper<DetailedSeason>(
      apiClient,
      { path: `/api/v${version}/battlepass/seasons` }
    )

    return {
      getSeason,
      seasons,
      getSeasonById,

      claimReward: (id: Level['id']) =>
        apiClient.post<ClaimResponse[]>(
          `/api/v${version}/battlepass/seasons/claim-reward/${id}`
        )
    }
  }
} satisfies Starter
